<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2022-05-13 17:56:02
 * @Description: 弹框旁的tabBar
 * @LastEditors: Please set LastEditors
-->
<template>
  <div :class="`position-absolute dialog_tab dialog_tab_${direction} `" :style="{ top: top }">
    <div
      class="dialog_tab_button tc"
      :class="
        row.val === currentCom || row.expand
          ? `dialog_tab_button_${direction} selected`
          : `dialog_tab_button_${direction}`
      "
      v-for="(row, index) in dialogList"
      :key="index"
      @click="switchDialog(row)"
    >
      <div class="h-100 w-100" @mouseenter="Mouseenter(row)" @mouseleave="Mouseleave(row)">
        <span
          v-if="row.expand && direction === 'right'"
          class="iconfont fz-12 text-color-white icon-yxr-zl"
        ></span>
        <el-tooltip :content="row.name" placement="right" effect="dark" :open-delay="1000">
          <!-- content to trigger tooltip here -->
          <span
            :class="row.expand ? ` ${row.iconName} fz-18` : `${row.iconName} fz-20`"
            class="iconfont text-color-white cur_pointer"
          ></span>
        </el-tooltip>
        <span
          v-if="row.expand && direction === 'left'"
          class="iconfont fz-12 icon-yxr-yl text-color-white"
        ></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    top: {
      type: String,
      default: '0rem',
    },
    direction: {
      type: String,
      default: 'left',
    },
    dialogList: {
      type: Array,
      default() {
        return [
          {
            expand: true,
            iconName: 'icon-yxr-mxs',
            maxHeight: '35rem',
            minHeight: '35rem',
            name: '模型树',
            unAllowCoexistCom: [],
            val: 'ModelTree',
          },
        ]
      },
    },
    currentCom: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      test: [
        {
          expand: false,
          iconName: 'icon-yxr-mxs',
          maxHeight: '35rem',
          minHeight: '35rem',
          name: '模型树',
          unAllowCoexistCom: [],
          val: 'ModelTree',
        },
      ],
    }
  },
  watch: {
    currentCom() {
      this.collationList()
    },
    dialogList() {
      this.collationList()
    },
  },
  created() {
    this.collationList()
  },
  methods: {
    collationList() {
      _.forEach(this.dialogList, (item) => {
        if (item.val === this.currentCom) {
          item.expand = true
        } else {
          item.expand = false
        }
      })
    },
    Mouseenter(row) {
      if (row.val !== this.currentCom) {
        row.expand = true
      }
    },
    Mouseleave(row) {
      if (row.val !== this.currentCom) {
        row.expand = false
      }
    },
    switchDialog(row) {
      this.$emit('switchDialog', row)
    },
  },
}
</script>
<style lang="scss" scoped>

.selected {
  background-color: #00c0ff !important;
}
.dialog_tab {
  width: 34px;
  z-index: 99;
  &_button {
    background-color: rgba(0, 116, 201, 0.8);
    margin-top: 2px;
    height: 34px;
    line-height: 34px;
    &_left {
      border-radius: 2px 5px 5px 2px;
    }
    &_right {
      border-radius: 5px 2px 2px 5px;
    }
  }
  &_right {
    right: 0px;
  }
}
.icon_right {
  transform: rotate(-180deg);
}

</style>
